import React from 'react'
import { Nav } from '../../components'
import { Footer } from '../../containers'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet'
import { images } from '../../constants'
import './Gallery.css'

const Gallery = () => {
  const imageAnimate = {
    offscreen: { x: 100, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }
  return (
    <motion.div
      initial={'offscreen'}
      whileInView={'onscreen'}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ staggerChildren: 0.5 }}
    >
      <Helmet>
        <title>Gallery - Sushi edge</title>
      </Helmet>
      <div className="container-xxl">
        <Nav />
      </div>

      <div className="gallery-container row  align-items-center p-5">
        <h1 className="text-center text-light mt-5 mb-5">Gallery</h1>
        <div className="col-lg-4 col-md-6 mb-5">
          <img
            src={images.gallery01}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-5">
          <img
            src={images.gallery02}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery03}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery04}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery05}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery06}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery07}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery08}
            class="img-fluid"
            alt="gallery"
          />
        </div>
        <div className="col-lg-4  col-md-6 mb-5">
          <img
            src={images.gallery09}
            class="img-fluid"
            alt="gallery"
          />
        </div>
      </div>
      <div className="container-xxl mt-5">
        <Footer />
      </div>
    </motion.div>
  )
}

export default Gallery
